// import Phaser from 'phaser'
import Config from '../launch/config'
import Missile from './missile'
import audio from '../launch/audio'

export default function shoot(otherShip, time, delta) {
    this.missile = new Missile(Config.scene, 'particleWhite')
    Config.scene.add.existing(this.missile)

    this.missile.setPosition(this.x, this.y)
    this.missile[Config.namespace] = {type: 'missile'}
    audio.shipShoot()

    // Anticipate where ship will be
    let duration = this.weaponSpeed
    let velocityMultiplier = duration / 10 / 2
    let x = otherShip.x
    let y = otherShip.y
    if (otherShip.sprite.body) {
        const {position, positionPrev, velocity} = otherShip.sprite.body

        if (position.y < positionPrev.y) {
            y = y - Math.abs(velocity.y * velocityMultiplier)
        }
        if (position.y > positionPrev.y) {
            y = y + Math.abs(velocity.y * velocityMultiplier)
        }
        if (position.x < positionPrev.x) {
            x = x - Math.abs(velocity.x * velocityMultiplier)
        }
        if (position.x > positionPrev.x) {
            x = x + Math.abs(velocity.x * velocityMultiplier)
        }
    }

    const tween = Config.scene.tweens.add({
        targets: this.missile,
        x,
        y,
        ease: 'Linear',
        duration,
        onComplete: (tween, targets) => {
            targets[0].destroy()
            let damage =
                Config.difficultyLevels[Config.difficulty]
                    .enemyShipWeaponDamage[Config.chance.d4() - 1]

            if (this.faction === 'userFactionName') {
                damage =
                    Config.shipRanks[`rank${this.rank}`].shipWeaponDamage[
                        Config.chance.d4() - 1
                    ]
            }

            otherShip.health -= damage

            // TODO: Add weapon impact efffect
            // var particles = Config.scene.add.particles('particleWhite')
            // var emitter = particles.createEmitter({
            //     speed: 100,
            //     lifespan: 200,
            //     scale: {start: 0.1, end: 0},
            //     alpha: 0.5,
            // })
            // emitter.setPosition(x, y)
            // setTimeout(() => {
            //     emitter.remove()
            // }, 200)
        },
    })

    tween.on('update', (tween, key, target) => {
        // TODO: Rotate elongated projectiles to correct angle
        // target.rotation = Math.atan2(y - target.y, x - target.x)
    })
}
